import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-addressprevious',
  templateUrl: './addressprevious.component.html',
  styleUrls: ['./addressprevious.component.less']
})
export class AddresspreviousComponent implements OnInit {

  @Input() formGroup: UntypedFormGroup;
  @Input() previousAddresses: string[];
  @Input() loading: boolean;
  @Output() onRemove: EventEmitter<string> = new EventEmitter();
  @Output() onSubmit: EventEmitter<string> = new EventEmitter();
  disabled: boolean;
  previousAddressInvalid: boolean;
  postalCodeExists: boolean = false;
  subscription: Subscription;

  constructor() { }

  ngOnInit(): void {
    this.previousAddressInvalid == false;
    this.subscription = this.formGroup.controls.previousAddress.valueChanges.subscribe(x => {
      if (this.previousAddressInvalid && !x) {
        this.previousAddressInvalid = false;
      }
      if (this.postalCodeExists && !x) {
        this.postalCodeExists = false;
      }
    })
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  removePreviousAddress(postalCode: string) {
    this.onRemove.emit(postalCode);
  }

  addPreviousAddress() {
    if (this.previousAddresses.find(x => x === this.formGroup.value.previousAddress)) {
      this.postalCodeExists = true;
    }
    else {
      this.postalCodeExists = false;
      this.onSubmit.emit();
    }

  }

  showValidation(field: string){
    if(this.formGroup.controls[field].invalid){
        this[field+"Invalid"] = true;
    }
    else{
        this[field+"Invalid"] = false;
    }
}
}
